import { useIntl } from "react-intl";

import { Button } from "@/components/Button/Button";
import { IconCutlery } from "@/components/Icons";
import { RequiredLabel } from "@/features/flights/components/additional-services/RequiredLabel";
import { InfoBadge } from "@/features/flights/components/InfoBadge";

type Props = {
  required?: boolean;
  selectedAmount?: number;
  onClick: () => void;
};

export const SelectMealCard = ({
  required,
  selectedAmount,
  onClick,
}: Props) => {
  const intl = useIntl();

  return (
    <div className="relative flex flex-col rounded-3xl bg-white p-1">
      <div className="flex items-center gap-1 p-3">
        <IconCutlery className="size-18 shrink-0" />
        <div>
          <div className="font-medium text-text-primary">
            {intl.formatMessage({
              defaultMessage: "Meal selection",
              description: "Section heading for meal selection for a traveller",
            })}
          </div>
          <div className="text-sm text-text-tertiary">
            {intl.formatMessage({
              defaultMessage:
                "Select your favourite type of onboard meal in advance",
              description:
                "Heading prompting the user to choose a meal type for a traveller",
            })}
          </div>
          {selectedAmount && selectedAmount > 0 ? (
            <InfoBadge
              label={intl.formatMessage(
                {
                  defaultMessage:
                    "{amount, plural, one {# Meal} other {# Meals}} selected",
                  description: "Count of meal options selected for a traveller",
                },
                { amount: selectedAmount },
              )}
            />
          ) : (
            <InfoBadge
              label={intl.formatMessage({
                defaultMessage: "Nothing selected",
                description:
                  "Status label when no option has been selected (e.g. no meal, no service)",
              })}
              dimmed
            />
          )}
        </div>
      </div>
      <div className="p-3 pt-1">
        <Button variant="outlined" fullWidth onClick={onClick}>
          {selectedAmount && selectedAmount > 0
            ? intl.formatMessage({
                defaultMessage: "Edit meal selection",
                description:
                  "Button to modify the meal selection for a traveller",
              })
            : intl.formatMessage({
                defaultMessage: "Select meal",
                description:
                  "Button label to select a meal option for a traveller",
              })}
        </Button>
      </div>
      {required ? <RequiredLabel /> : null}
    </div>
  );
};
